import { render, staticRenderFns } from "./AppVersionUpgradeLogModal.Style#Drawer.vue?vue&type=template&id=fbdfcbec&scoped=true&"
import script from "./AppVersionUpgradeLogModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./AppVersionUpgradeLogModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionUpgradeLogModal.Style#Drawer.vue?vue&type=style&index=0&id=fbdfcbec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdfcbec",
  null
  
)

export default component.exports